import type { ProviderConnection } from '@shared/types/integrations';

export const hasConnectedProviderConnection = (
  connections: ProviderConnection[] | undefined
): boolean => {
  return (connections || []).some((connection) => connection.connected);
};
